<div class="bottom-sheet">
  <custom-app-bar
    [title]="'add_to_cart_bottom_sheet.title' | translate"
    [hasCloseButton]="true"
    [hasSafeArea]="false"
    [closeButtonReturnToThePreviousPage]="false"
    (onClickCloseButton)="closeBottomSheetWithoutSendData()"
  ></custom-app-bar>

  <hr class="divider-line" />

  <div class="number-selector" [formGroup]="quantityFormGroup">
    <div class="selection" *ngFor="let number of [0, 1, 2, 3, 4, 5]">
      <custom-radio-button
        class="selection__radio-button"
        [id]="number"
        [value]="number"
        [checked]="quantityControl.value === number"
        formControlName="quantity"
      ></custom-radio-button>
      <p class="selection__label">{{ number }}</p>
    </div>
  </div>

  <hr class="divider-line" />

  <div class="custom-quantity">
    <p class="custom-quantity__label">
      {{ "add_to_cart_bottom_sheet.other_quantity" | translate }}
    </p>
    <custom-form-field
      type="number"
      class="custom-quantity__field"
      [formGroup]="quantityFormGroup"
      controlName="quantity"
      [label]="
        'add_to_cart_bottom_sheet.quantity_form_field_placeholder' | translate
      "
    ></custom-form-field>
  </div>

  <hr class="divider-line" />

  <div class="action-buttons">
    <button
      customButton
      appearance="ghost"
      expand="full"
      (click)="closeBottomSheetWithoutSendData()"
    >
      {{ "add_to_cart_bottom_sheet.cancel" | translate }}
    </button>
    <button
      customButton
      expand="full"
      [disabled]="!(quantityControl.value >= 0)"
      (click)="closeBottomSheet()"
    >
      {{ "add_to_cart_bottom_sheet.accept" | translate }}
    </button>
  </div>
</div>
